module.exports = __webpack_public_path__ + "static/Usuarios-Registrados-00a2611ce7b468e5d3c4282358034b57.svg";